export const SECTORS = [
  'Inmobiliaria',
  'Cocinas y reformas',
  'Automoción',
  'Restauración',
  'Ecommerce',
  'Servicios profesionales',
  'Salud y bienestar',
  'Formación',
  'Otro',
] as const

export const SECTOR_OPTIONS = SECTORS.map((s) => ({ value: s, label: s }))
